"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useEADebugPanel;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _EADebugPanel = _interopRequireDefault(require("./EADebugPanel"));

var _EAStateConnector = _interopRequireDefault(require("./connectors/EAStateConnector"));

var _modes = require("./constants/modes");

var _getEventTrackingConfig = _interopRequireDefault(require("./config/getEventTrackingConfig"));

var _storage = _interopRequireWildcard(require("./storage/storage"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/*
 * `useEADebugPanel` is a custom hook that handles the ?eaDebugPanel query param,
 * as well as listening to window.EkoAnalytics' eventemitter "track" events
 * and remembering which track calls have happened
 */


var SESSION_CONFIG_KEY = 'config-session';
var PREVIOUS_RECORDS_KEY = 'previous-track-records';

function getConfigSync(_x) {
  return _getConfigSync.apply(this, arguments);
}

function _getConfigSync() {
  _getConfigSync = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(useLocalConfig) {
    var storage, _config, config;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            storage = (0, _storage["default"])(_storage.storageTypes.SESSION);

            if (!storage.getItem(SESSION_CONFIG_KEY)) {
              _context.next = 4;
              break;
            }

            _config = JSON.parse(storage.getItem(SESSION_CONFIG_KEY));
            return _context.abrupt("return", {
              setConfigSession: false,
              config: _config
            });

          case 4:
            _context.next = 6;
            return (0, _getEventTrackingConfig["default"])(useLocalConfig);

          case 6:
            config = _context.sent;
            return _context.abrupt("return", {
              setConfigSession: true,
              config: config
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getConfigSync.apply(this, arguments);
}

function useEADebugPanel(weSdkVersion, useLocalConfig) {
  // Do this asynchronously / with state and a useEffect hook because if we did it at top-level,
  // a server-side render wouldn't have document available and the logic wouldn't run / parse
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      EADebugMode = _useState2[0],
      setEADebugMode = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      defaultRelevantFields = _useState4[0],
      setDefaultRelevantFields = _useState4[1];

  (0, _react.useEffect)(function () {
    if (typeof document === 'undefined') {
      return;
    }

    var queryParams = new URL((document || {}).location || '').searchParams;
    var eaDebugPanelParam = queryParams.get('eaDebugPanel');
    var mode;

    if (eaDebugPanelParam === 'true') {
      // 'true' is the default 'enabled' value, so assume it means 'parent'
      mode = _modes.MODES.PARENT;
    } else if (eaDebugPanelParam === 'popout') {
      mode = _modes.MODES.POPOUT;
    }

    getConfigSync(useLocalConfig).then(function (_ref) {
      var setConfigSession = _ref.setConfigSession,
          config = _ref.config;

      if (setConfigSession) {
        (0, _storage["default"])(_storage.storageTypes.SESSION).setItem(SESSION_CONFIG_KEY, JSON.stringify(config));
      }

      setDefaultRelevantFields(config.defaultRelevantFields);
      setEADebugMode(mode);
    });
  }, []);

  var _connectEAState = (0, _EAStateConnector["default"])(EADebugMode, useLocalConfig),
      trackRecords = _connectEAState.trackRecords,
      setTrackRecords = _connectEAState.setTrackRecords;

  var debugPanel = null;

  if (EADebugMode) {
    debugPanel = /*#__PURE__*/_react["default"].createElement(_EADebugPanel["default"], {
      mode: EADebugMode,
      trackRecords: trackRecords,
      clearTrackRecords: function clearTrackRecords() {
        setTrackRecords([]);
        (0, _storage["default"])(_storage.storageTypes.SESSION).removeItem(PREVIOUS_RECORDS_KEY);
      },
      weSdkVersion: weSdkVersion,
      defaultRelevantFields: defaultRelevantFields
    });
  }

  return debugPanel;
}